import './FuelPrice.scss';
import React, { useEffect, useState } from 'react';
export default function FuelPrice({ fields, fuelPrice, onChange }) {
  const [value, setValue] = useState('');
  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (!/^\d*\.?\d*$/.test(inputValue)) return;
    const decimalMatch = inputValue.match(/^\d+\.(\d{3,})$/);
    if (decimalMatch) return;
    setValue(inputValue);
    onChange(inputValue);
  };

  const handleDecrement = () => {
    setValue((prev) => {
      const numericValue = parseFloat(prev) || 0;
      const newValue = Math.max(numericValue - 0.01, 0);
      onChange(newValue.toFixed(2));
      return newValue.toFixed(2);
    });
  };

  const handleIncrement = () => {
    setValue((prev) => {
      const numericValue = parseFloat(prev) || 0;
      onChange((numericValue + 0.01).toFixed(2));
      return (numericValue + 0.01).toFixed(2);
    });
  };

  useEffect(() => {
    setValue(fuelPrice);
    onChange(fuelPrice);
  }, [fuelPrice]);

  return (
    <div className={'FuelPrice'}>
      <div className={'wrapper'}>
        <h4 className={'label'}>{fields?.inputTitle?.value}</h4>
        <div className={'item_inputContainer'}>
          <div className={'item_inputContainer_decrement'} onClick={handleDecrement}>
            <img src={fields?.minus?.value.src} alt="-" />
          </div>
          <div className={'item_inputContainer_input'}>
            <input value={value} onChange={handleChange} />
          </div>
          <div className={'item_inputContainer_increment'} onClick={handleIncrement}>
            <img src={fields?.add?.value.src} alt="+" />
          </div>
        </div>
      </div>
    </div>
  );
}
